import { RootState } from "lib/store"

export const selectInsightsFilteredDays = (state: RootState) => state.insights.filteredDays
export const selectInsightsStartDate = (state: RootState) => state.insights.startDate
export const selectInsightsEndDate = (state: RootState) => state.insights.endDate
export const selectInsightsSelectedStoreGroups = (state: RootState) => state.insights.selectedStoreGroups
export const selectInsightsSelectedStoreMarkets = (state: RootState) => state.insights.selectedStoreMarkets
export const selectInsightsSelectedReasons = (state: RootState) => state.insights.selectedReasons
export const selectInsightsNumberOfHits = (state: RootState) => state.insights.numberOfHits
export const selectInsightsTimeZone = (state: RootState) => state.insights.timeZone
